import * as React from 'react';
import { ListWrapper, EventWrapper, StyledListItemText, Title, StyledListIcon, StyledBoldListItemText } from './style'

import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import BadgeIcon from '@mui/icons-material/Badge';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import { Event } from '../Components/Calendar'
import { map } from 'lodash'
import { Dayjs } from 'dayjs';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EventIcon from '@mui/icons-material/Event';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import PinDropIcon from '@mui/icons-material/PinDrop';
import { useHorsesStore } from '../../../stores/horses';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import Upload, { FileList } from '../Records/Upload';
import { observer } from "mobx-react";
import { toJS } from 'mobx';
import { Accordion, AccordionDetails, AccordionSummary, Box } from '@mui/material';
export interface EventProps {
    events: Event[],
    day: Dayjs,
    deleteHandle: (id: string) => void
}
const DeleteButton = styled(IconButton)`
    .my-mui-app div & {
        background-color:transparent !important;
    }
    
`
const App: React.FC<EventProps> = ({ events, day, deleteHandle }) => {
    const store = useHorsesStore()
    const location = useLocation();

    const current = React.useMemo(() => {
        events.map(item => {
            const event = store.calendar.find(calendar => calendar._ID == item._ID)
            if (event) {

                item.email = event.email;
                item.horseName = event.horseName;
                item.phone = event.phone;
                item.usrName = event.usrName;
            }
        })
        console.log(toJS(events))
        return events
    }, [events, store.calendar])



    return <React.Fragment>

        {current && current.length > 0 &&

            <EventWrapper>
                <Title variant='h4' sx={{ fontWeight: 800, marginBottom: '16px', marginTop: '16px', color: '#408697' }}>{day.format('D-MMM-YYYY')}</Title>
                <ListWrapper>

                    {map(events, (item, index) => {
                        const horse = item.horseName ? item.horseName : item.calendar_type == 'Public' ? item.public_type : 'Event'
                        const title = item.title ? item.title : 'unnamed'
                        return <Accordion sx={{ boxShadow: 'none' }}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`panel${String(index)}-content`}
                                id={`panel${String(index)}-header`}
                            >
                                <ListItem alignItems="flex-start" secondaryAction={
                                    store.getUserRole() == true ?
                                        <DeleteButton edge="end" aria-label="delete" onClick={() => deleteHandle(item._ID)}>
                                            <DeleteIcon />
                                        </DeleteButton> : <></>
                                }>
                                    <StyledBoldListItemText
                                        primary={`${horse} - ${title}`}

                                    />
                                </ListItem>
                            </AccordionSummary>

                            {item.horseName != undefined ? <AccordionDetails>
                                <ListItem alignItems="flex-start">
                                    <StyledListItemText
                                        primary={'Horse'}
                                        secondary={
                                            <>
                                                <StyledListIcon>
                                                    <TextSnippetIcon color={'primary'} />
                                                </StyledListIcon>
                                                {item.horseName}
                                            </>
                                        }
                                    />

                                </ListItem>
                                <ListItem alignItems="flex-start">
                                    <StyledListItemText
                                        primary={'Name'}
                                        secondary={
                                            <>
                                                <StyledListIcon>
                                                    < BadgeIcon color={'primary'} />
                                                </StyledListIcon>
                                                {item.usrName}
                                            </>
                                        }
                                    />

                                </ListItem>
                                <ListItem alignItems="flex-start">
                                    <StyledListItemText
                                        primary={'Email'}
                                        secondary={
                                            <>
                                                <StyledListIcon>
                                                    <EmailIcon color={'primary'} />
                                                </StyledListIcon>
                                                {item.email}
                                            </>
                                        }
                                    />

                                </ListItem>

                                <ListItem alignItems="flex-start">
                                    <StyledListItemText
                                        primary={'Phone'}
                                        secondary={
                                            <>
                                                <StyledListIcon>
                                                    <PhoneAndroidIcon color={'primary'} />
                                                </StyledListIcon>
                                                {item.phone}
                                            </>
                                        }
                                    />

                                </ListItem>
                                <ListItem alignItems="flex-start">
                                    <StyledListItemText
                                        primary={'Address'}
                                        secondary={
                                            <>
                                                <StyledListIcon>
                                                    <PinDropIcon color={'primary'} />
                                                </StyledListIcon>
                                                {item.address}
                                            </>
                                        }
                                    />

                                </ListItem>
                            </AccordionDetails>
                                : <AccordionDetails>
                                    <Box sx={{ flexDirection: 'row', display: 'flex' }}>
                                        <ListItem alignItems="flex-start">
                                            <StyledListItemText
                                                primary={'Start From'}
                                                secondary={
                                                    <>
                                                        <StyledListIcon>
                                                            <CalendarMonthIcon color={'primary'} />
                                                        </StyledListIcon>
                                                        {item.date.format('DD/MM/YYYY-HH:mm')}
                                                    </>
                                                }
                                            />

                                        </ListItem>
                                        <ListItem alignItems="flex-start">
                                            <StyledListItemText
                                                primary={'End to'}
                                                secondary={
                                                    <>
                                                        <StyledListIcon>
                                                            <CalendarMonthIcon color={'primary'} />
                                                        </StyledListIcon>
                                                        {item.endDate ? item.endDate.format('DD/MM/YYYY-HH:mm') : item.date.format('DD/MM/YYYY-HH:mm')}
                                                    </>
                                                }
                                            />

                                        </ListItem>
                                    </Box>
                                    <Box sx={{ flexDirection: 'row', display: 'flex' }}>
                                        {item.calendar_type == 'Public' ?
                                            <ListItem alignItems="flex-start">
                                                <StyledListItemText
                                                    primary={'Region'}
                                                    secondary={
                                                        <>
                                                            <StyledListIcon>
                                                                <PinDropIcon color={'primary'} />
                                                            </StyledListIcon>
                                                            {item.regions}
                                                        </>
                                                    }
                                                />

                                            </ListItem>
                                            : null}

                                        <ListItem alignItems="flex-start">
                                            <StyledListItemText
                                                primary={'Address'}
                                                secondary={
                                                    <>
                                                        <StyledListIcon>
                                                            <PinDropIcon color={'primary'} />
                                                        </StyledListIcon>
                                                        {item.address}
                                                    </>
                                                }
                                            />

                                        </ListItem>
                                    </Box>

                                    {item.calendar_type == 'Public' ?
                                        <ListItem alignItems="flex-start">
                                            <StyledListItemText
                                                primary={'Contact Email'}
                                                secondary={
                                                    <>
                                                        <StyledListIcon sx={{ marginRight: '10px' }}>
                                                            <EmailIcon color={'primary'} />
                                                        </StyledListIcon>
                                                        {item.event_email}
                                                    </>
                                                }
                                            />

                                        </ListItem>
                                        : null}
                                    {item.calendar_type == 'Public' ?
                                        <ListItem alignItems="flex-start">
                                            <StyledListItemText
                                                primary={'Event Link'}
                                                secondary={
                                                    <>
                                                        <StyledListIcon sx={{ marginRight: '10px' }}>
                                                            <EmailIcon color={'primary'} />
                                                        </StyledListIcon>
                                                        {item.link}
                                                    </>
                                                }
                                            />

                                        </ListItem>
                                        : null}
                                    <ListItem alignItems="flex-start">
                                        <StyledListItemText
                                            primary={'Description'}
                                            secondary={
                                                <>
                                                    <StyledListIcon>
                                                        <SpeakerNotesIcon color={'primary'} />
                                                    </StyledListIcon>
                                                    {item.notes}
                                                </>
                                            }
                                        />

                                    </ListItem>
                                    <ListItem alignItems="flex-start">
                                        <StyledListItemText
                                            primary={'Attachments'}
                                            secondary={
                                                <FileList queryId={item._ID} />
                                            }
                                        />

                                    </ListItem>
                                </AccordionDetails>}
                            {events.length - 1 !== index ? <Divider variant="fullWidth" component="li" /> : null}
                        </Accordion>
                    })
                    }
                </ListWrapper>
            </EventWrapper>

        }

    </React.Fragment>






}

export default observer(App)